import React from 'react';
import BaseTabContext from '@material-ui/lab/TabContext';

const TabContext = (props) => <BaseTabContext {...props} />;

export default TabContext;
